/**
 * Created by claude on 12.02.2026
 */

Meta.GetAvailableLocations = function () {
    const locations = LocationConfigResolver.resolveLocationsList(cleverapps.config.locations);

    locations[0] = {
        id: 0,
        slotId: Meta.SLOT_MAIN,
        locationType: "hose",
        retire: false,
        usesStars: true
    };

    return locations;
};
